import type { IsoDate } from './dates.ts';

export type TransactionKind =
  | 'EXPENSE'
  | 'INCOME'
  | 'TRANSFER'
  | 'REFUND'
  | 'SETTLEMENT_PAYMENT'
  | 'BALANCE_ADJUSTMENT';
export type TransactionStatus = 'PENDING' | 'BOOKED' | 'REVERSED' | 'CANCELLED';

export type AccountType =
  | 'CURRENT'
  | 'SAVINGS'
  | 'CREDIT_CARD'
  | 'CASH'
  | 'INVESTMENT'
  | 'LOAN'
  | 'MORTGAGE'
  | 'ASSET'
  | 'LIABILITY';

export const LIABILITY_TYPES: ReadonlySet<AccountType> = new Set(['CREDIT_CARD', 'LOAN', 'MORTGAGE', 'LIABILITY']);

/** What finance-core needs from a transaction (a projection of the synced aggregate). */
export type LedgerTransaction = {
  readonly id: string;
  readonly accountId: string;
  readonly bookingDate: IsoDate;
  /** Signed from the account's perspective: outflow negative. */
  readonly amountMinor: bigint;
  readonly currency: string;
  /** Amount in the household base currency at the booking-date rate; null if not converted yet. */
  readonly baseAmountMinor: bigint | null;
  readonly kind: TransactionKind;
  readonly status: TransactionStatus;
  readonly categoryId: string | null;
  readonly counterpartAccountId: string | null;
  readonly splits: readonly { readonly amountMinor: bigint; readonly categoryId: string | null }[];
};

export type LedgerAccount = {
  readonly id: string;
  readonly type: AccountType;
  readonly currency: string;
  readonly balanceMinor: bigint;
  /** Counts towards "Savings & investments" (savings accounts, Trading 212, marked assets). */
  readonly isSavingsAsset: boolean;
  readonly includeInNetWorth: boolean;
  readonly archivedAt: string | null;
};
